@if (content$ | async; as content) {
  <div>
    <h1 class="nordic-blue-900-text text-icon-primary mr-small-b ms-clear-t font-heading-1 font-headline-medium">
      {{ content.teaserTitle }}
    </h1>
    @if (content.teaserText) {
      <div
        [innerHTML]="
          content.teaserText
            | finAddClasses
              : {
                  a: 'font-body-2 font-body-small nordic-blue-900-text text-icon-primary',
                  p: 'font-body-2 font-body-small nordic-blue-400-text text-icon-primary',
                }
            | finSafe: 'html'
        "
        class="ms-large-t ms-large-b"
      ></div>
    }
  </div>

  <form
    class="service-form radio-list"
    [attr.data-testid]="formTestId$ | async"
    [formGroup]="form"
    (ngSubmit)="navigateBasedOnTheChoice()"
  >
    <div class="rounded-large white-bg surface-primary border">
      @for (radioItem of content.items; track radioItem) {
        <fin-form-input-radio
          [controlName]="RadioLevels.TOP_LEVEL"
          [parentForm]="group"
          [isSensitive]="true"
          [description]="true"
          [descriptionTitle]="radioItem.teaserTitle"
          [descriptionText]="radioItem.teaserText | finStripHtml"
          [radioKey]="$any(radioItem)"
          data-testid="radio-list-compensation-form-categories"
          #category
        >
          @if (radioItem.contentType === 'CMCollection' && group.value.topLevel === radioItem) {
            @for (radioSubItem of radioItem.items; track radioSubItem) {
              <fin-form-input-radio
                [controlName]="RadioLevels.SUB_LEVEL"
                [parentForm]="group"
                [isSensitive]="true"
                [description]="true"
                [descriptionTitle]="radioSubItem.teaserTitle"
                [descriptionText]="radioSubItem.teaserText | finStripHtml"
                [radioKey]="$any(radioSubItem)"
                data-testid="radio-list-compensation-sub-categories"
              />
            }
          }
        </fin-form-input-radio>
      }
    </div>

    <div class="mr-medium-y ps-small-t fill">
      <fcom-button
        class="submit-data"
        [mode]="ButtonMode.FILL"
        [type]="ButtonType.SUBMIT"
        [theme]="ButtonTheme.PRIMARY_ACCENT"
        [disabled]="!form.valid"
        [text]="'SERVICE_FORMS.CSServiceForms.wizard.continue' | finLocalization"
        data-testid="compensation-form-submit-button"
      />
    </div>
  </form>
}
